import React, { useEffect, useState } from 'react';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';
import { styled } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { Alert } from 'components';
import LinearProgressWithLabel from './LinearProgressWithLabel';
import { ProgressBarProps } from './Progress.props';

const PREFIX = 'ProgressBar';

const classes = {
  progressBar: `${PREFIX}-progressBar`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.progressBar}`]: {
    height: 64,
    border: `2px solid ${theme.palette.secondary[500]}`,
    borderRadius: '0.25rem',
    backgroundColor: 'white',
    '&&& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: `${theme.palette.secondary[200]}`,
    },
  },
}));

const ProgressBar = ({ droppedFiles, file, progress }: ProgressBarProps) => {
  const [uploadedFile, setUploadedFile] = useState<boolean>(false);

  useEffect(() => {
    if (!droppedFiles.includes(file)) {
      setUploadedFile(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (progress === 100) {
      setUploadedFile(true);
    }
  }, [progress]);

  return (
    <StyledBox>
      {!uploadedFile ? (
        <LinearProgressWithLabel value={progress} file={file} />
      ) : (
        <Alert isAlertVisible icon={<CheckCircleOutlineIcon />} severity="success">
          <Typography style={{ fontSize: '0.875rem' }}>{file?.name}</Typography>
        </Alert>
      )}
    </StyledBox>
  );
};

export default ProgressBar;
